import { NextButton } from './NextButton'
import { PrevButton } from './PrevButton'
import { StartButton } from './StartButton'
import { CompleteSessionButton } from './CompleteSessionButton'
import { useTechnicianDocument } from '../hooks/useTechnicianDocument'
import { useTechnicianPageStore } from '../hooks/useTechnicianPageStore'

export const ControlBar = () => {
  const { prevPage, nextPage, isLoading } = useTechnicianDocument()
  const currentTechnician = useTechnicianPageStore(
    (state) => state.currentTechnician,
  )

  if (isLoading) {
    return null
  }

  return (
    <div className="flex justify-between z-[50] bg-white sticky bottom-0 border-t py-4 px-4 !my-0">
      {currentTechnician && (
        <>
          <PrevButton prevId={prevPage?.id || null} />

          {nextPage && nextPage.id ? (
            <NextButton nextId={nextPage.subPageId || nextPage?.id || null} />
          ) : (
            <CompleteSessionButton />
          )}
        </>
      )}

      {!currentTechnician && (
        <>
          <span></span>
          <StartButton />
          <span></span>
        </>
      )}
    </div>
  )
}
